export default __webpack_public_path__ + "static/media/minecraft.c02ee728.webp";